import R from 'ramda'
import { fromNullable, Just, Nothing } from 'data.maybe'
import querystring from 'querystring'
import { getCredentials } from './pgads'
// import { post, get, createFetchTask } from '@integec/fetch-task'
const fromEmpty = val =>
  fromNullable(val).chain(v => (R.isEmpty(v) ? Nothing() : Just(v)))

// const baseUrl='http://localhost:9898'

const url = ({ baseUrl }, target) => `${baseUrl}/${target}`

// const toDate = moment => moment.format('YYYY-MM-DD')

/** need to put security info here **/
const authHeader = ({ jwt, ignoreAuth }) =>
  jwt && !ignoreAuth ? { Authorization: `JWT ${jwt}` } : {}

const post = (targetInfo, target, options) => payload =>
  fetch(url(targetInfo, target), {
    method: 'POST',
    ...getCredentials(targetInfo),
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(options ? { ...targetInfo, ...options } : targetInfo),
    },
    body: JSON.stringify(payload),
  })

/** need to put security info here **/
const get = (targetInfo, target) =>
  fetch(url(targetInfo, target), {
    headers: authHeader(targetInfo),
    credentials:
      targetInfo.fetchCredentials == null
        ? undefined
        : targetInfo.fetchCredentials,
  })

const toYearMonth = yearMonth =>
  fromEmpty(yearMonth)
    .map(({ year, month }) => ({ year, month }))
    .getOrElse('')

const toPayload = ({ from, to }, unitList, groups) => ({
  start: toYearMonth(from),
  end: toYearMonth(to),
  units: unitList || undefined,
  groups: groups || undefined,
})

const toRequest = ({ period: { from, to }, ...rest }) => ({
  start: toYearMonth(from),
  end: toYearMonth(to),
  ...rest,
})

export const doLogin = targetInfo => props =>
  post(targetInfo, 'auth/token')(props)

export const getUnitNameMap = targetInfo => () =>
  get(targetInfo, 'units/nameMap')

export const getUnitGroups = targetInfo => _ => get(targetInfo, 'units/groups')

export const getUnitIds = targetInfo => _ => get(targetInfo, 'units/ids')

export const getGadsKpi = targetInfo => (props, unitList, groups) =>
  post(targetInfo, 'oa/kpi')(toPayload(props, unitList, groups))

export const getGadsKpiByGroup = targetInfo => (props, group) =>
  post(targetInfo, 'oa/kpi/byGroup')(toPayload(props, null, group))

export const getAgEFORD = targetInfo => props =>
  post(targetInfo, 'oa/ag-eford')(toPayload(props))

export const getEfordContrib = targetInfo => props =>
  post(targetInfo, 'oa/eford-contrib')(toPayload(props))

export const getKpiSpec = targetInfo => _ => get(targetInfo, 'oa/kpi-spec')

export const getKpiContrib = targetInfo => (props, unitList) =>
  post(targetInfo, 'oa/kpi-contrib')(toPayload(props, unitList))

export const getKpiCAContrib = targetInfo => (props, unitList) =>
  post(targetInfo, 'oa/kpi-ca-contrib')(toPayload(props, unitList))

export const getAgKpi = targetInfo => (props, unitList) =>
  post(targetInfo, 'oa/ag-kpi')(toPayload(props, unitList))

export const getAgCAKpi = targetInfo => (props, unitList) =>
  post(targetInfo, 'oa/ag-ca-kpi')(toPayload(props, unitList))

export const getContribKeys = targetInfo => () =>
  get(targetInfo, 'oa/contrib-elements')

export const getCAContribKeys = targetInfo => () =>
  get(targetInfo, 'oa/ca-contrib-elements')

export const getKpiGoals = targetInfo => year =>
  get(targetInfo, `oa/kpi-goals?year=${year}`)

export const getCaDataByUnit = targetInfo => req =>
  post(targetInfo, 'ca/summarize-by-unit')(toRequest(req))

export const getCaDataByGroup = targetInfo => req =>
  post(targetInfo, 'ca/summarize-by-group')(toRequest(req))

export const getWeeklyLostOppRevenue = targetInfo => req =>
  post(targetInfo, 'ca/weekly-lost-opp-revenue')(toRequest(req))

export const getGadsDataByUnit = targetInfo => req =>
  post(targetInfo, 'gads/summarize-by-unit')(toRequest(req))

export const getGadsDataByGroup = targetInfo => req =>
  post(targetInfo, 'gads/summarize-by-group')(toRequest(req))

export const getGadsMonthlyByUnit = targetInfo => req =>
  post(targetInfo, 'gads/monthly-values-unit')(toRequest(req))

export const getGadsMonthlyByGroup = targetInfo => req =>
  post(targetInfo, 'gads/monthly-values-group')(toRequest(req))

export const getPnlWeeklyData = targetInfo => _ => get(targetInfo, 'pnl/weekly') // (toRequest(req))

export const forecastMetrics = targetInfo => req =>
  get(targetInfo, `oa/forecast?${querystring.stringify(req)}`)
